<script lang="ts" module>
  import type { SystemStyleObject } from '@agapi/ui/panda/types';
  import type { Snippet } from 'svelte';

  export type ShortDatedBadgeProps = {
    /** Custom CSS styles for the component */
    css?: SystemStyleObject;
    /** The size of the badge */
    size?: 'xs' | 'sm' | 'md' | 'lg';
    /** Icon snippet to display */
    icon?: Snippet;
  };
</script>

<script lang="ts">
  import { Badge } from '@agapi/ui/badge';
  import { Warning } from 'phosphor-svelte';
  import * as m from '$lib/parachute/messages';

  const { css: cssProp, size = 'sm', icon }: ShortDatedBadgeProps = $props();
</script>

<Badge
  colorVariant="tertiary.subdued"
  size={size}
  rounded="full"
  css={cssProp}
  icon={icon}
>
  {m.shortDated()}
</Badge>
